"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.UpdatedApiKeyImpulse = void 0;
var ApiKey_1 = require("./ApiKey");
/**
 * Impulse which indicates the result of a update api key impulse
 */
var UpdatedApiKeyImpulse = /** @class */ (function (_super) {
    __extends(UpdatedApiKeyImpulse, _super);
    function UpdatedApiKeyImpulse() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._typeName = "UpdatedApiKeyImpulse";
        _this.id = function () {
            _this.push(function (_) { return "id"; });
        };
        _this.data = function (config) { return _this.push(function (registry) {
            var entity = new ApiKey_1.ApiKey();
            config(entity);
            return "data { " + entity.render(registry) + " }";
        }); };
        _this.render = function (registry) { return _this.map(function (e) { return e(registry); }).join(" "); };
        return _this;
    }
    return UpdatedApiKeyImpulse;
}(Array));
exports.UpdatedApiKeyImpulse = UpdatedApiKeyImpulse;
//# sourceMappingURL=UpdatedApiKeyImpulse.js.map